import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { UTC_DATE_REGEX } from '../constants/system-constants.model';

@Pipe({
  name: 'timeDifference',
  standalone: true,
  pure: false
})
export class TimeDifferencePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: string | Date | null | undefined): string {
    if (!value) return '';

    const dateString = typeof value === 'string' ? value.trim() : null;
    const isUTCFormat = dateString && UTC_DATE_REGEX.test(dateString);
    const dateToParse = isUTCFormat ? dateString + 'Z' : value;

    const momentDate = moment(dateToParse);
    if (!momentDate.isValid()) return '';

    const seconds = moment().diff(momentDate, 'seconds');
    if (seconds < 0 || seconds < 60)
      return `${this.translate.instant('NOTIFICATION.TIME.NOW')}`;

    const minutes = moment().diff(momentDate, 'minutes');
    if (minutes < 60)
      return `${minutes} ${this.translate.instant('NOTIFICATION.TIME.MIN')}`;

    const hours = moment().diff(momentDate, 'hours');
    if (hours < 24)
      return `${hours} ${this.translate.instant('NOTIFICATION.TIME.HOURS')}`;

    const days = moment().diff(momentDate, 'days');
    if (days < 30)
      return `${days} ${this.translate.instant('NOTIFICATION.TIME.DAYS')}`;

    const months = moment().diff(momentDate, 'months');
    if (months < 12)
      return `${months} ${this.translate.instant('NOTIFICATION.TIME.MONTH')}`;

    const years = moment().diff(momentDate, 'years');
    return `${years} ${this.translate.instant('NOTIFICATION.TIME.YEARS')}`;
  }
}